(() => {
  const videoInfo = (value) => {
    try {
      const url = new URL(value, location.origin);
      if (url.hostname === 'youtu.be' && /^[a-zA-Z0-9_-]{11}$/.test(url.pathname.slice(1))) return { id: url.pathname.slice(1), type: 'youtube' };
      if (['www.youtube.com','youtube.com','www.youtube-nocookie.com','youtube-nocookie.com'].includes(url.hostname)) {
        const playlist = url.searchParams.get('list');
        if ((url.pathname === '/embed/videoseries' || url.pathname === '/playlist') && playlist && /^[a-zA-Z0-9_-]+$/.test(playlist)) return { id: playlist, type: 'youtube-playlist' };
        const id = url.pathname.startsWith('/embed/') ? url.pathname.split('/')[2] : url.searchParams.get('v');
        if (id && /^[a-zA-Z0-9_-]{11}$/.test(id)) return { id, type: 'youtube' };
      }
      if (['vimeo.com','www.vimeo.com','player.vimeo.com'].includes(url.hostname)) {
        const id = url.pathname.split('/').filter(Boolean).pop();
        if (/^\d+$/.test(id)) return { id, type: 'vimeo' };
      }
    } catch {}
    return null;
  };
  const init = (scope) => scope.querySelectorAll('[data-ft-article]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const body = root.querySelector('[data-ft-body]');
    const frames = body ? [...body.querySelectorAll('iframe')] : [];
    const firstBodyVideo = frames.map(frame => ({ frame, info: videoInfo(frame.getAttribute('src')) })).find(item => item.info);
    const linkedVideo = body ? [...body.querySelectorAll('a[href]')].map(link => videoInfo(link.getAttribute('href'))).find(Boolean) : null;
    const video = root.dataset.videoId ? { id: root.dataset.videoId, type: root.dataset.videoType } : firstBodyVideo?.info || videoInfo(root.dataset.videoFallback) || linkedVideo;
    const poster = root.querySelector('[data-ft-poster]');
    const actions = root.querySelector('[data-ft-actions]');
    const player = root.querySelector('[data-ft-player]');
    const watch = root.querySelector('[data-ft-watch]');
    if (video && ['youtube','youtube-playlist','vimeo'].includes(video.type)) {
      const pending = root.querySelector('[data-ft-pending]');
      if (pending) pending.hidden = true;
      frames.forEach(frame => {
        const info = videoInfo(frame.getAttribute('src'));
        if (info && info.id === video.id && info.type === video.type) frame.remove();
      });
      actions.hidden = false;
      watch.addEventListener('click', () => {
        if (!player.querySelector('iframe')) {
          const iframe = document.createElement('iframe');
          if (video.type === 'youtube-playlist') iframe.src = `https://www.youtube-nocookie.com/embed/videoseries?list=${encodeURIComponent(video.id)}&autoplay=1&rel=0`;
          else iframe.src = video.type === 'youtube' ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(video.id)}?autoplay=1&rel=0` : `https://player.vimeo.com/video/${encodeURIComponent(video.id)}?autoplay=1`;
          iframe.title = player.dataset.playerTitle;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          player.append(iframe);
        }
        poster.hidden = true;
        player.hidden = false;
        actions.hidden = true;
        player.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        player.querySelector('iframe').focus({ preventScroll: true });
      });
    }
    if (!poster.querySelector('img') && !video) root.querySelector('[data-ft-media]').hidden = true;
    if (body) {
      if (root.querySelector('h1')?.textContent.trim() === 'Markus Mahler') {
        body.querySelectorAll('img[src*="IMG_1797.jpg"]').forEach(image => image.remove());
        body.querySelectorAll('p').forEach(node => {
          const text = node.textContent.replace(/\s+/g, ' ').trim();
          if (text.startsWith('If you want to understand what it means to grow beyond your limits') || text.startsWith('Full video:')) node.remove();
        });
        body.querySelectorAll('a[href*="PL3773rAGidqgNmV-veQxjXP1eEgwMBurq"]').forEach(link => {
          if (link.querySelector('img[src*="YouTube_Button.jpg"]')) link.remove();
        });
      }
      if (['Daniel Tschümperlin', 'Fabian Herdieckerhoff'].includes(root.querySelector('h1')?.textContent.trim())) {
        const more = [...body.querySelectorAll('h2,h3,h4')].find(node => /^More Flash/i.test(node.textContent.trim()));
        if (more) {
          const range = document.createRange();
          range.setStartBefore(more);
          range.setEnd(body, body.childNodes.length);
          range.deleteContents();
        }
      }
      const anjaImage = body.querySelector('img[src*="Anja_Graf_1189dfd7-e1d2-4206-b77b-a9cd5059f6a0.jpg"]');
      if (anjaImage) {
        anjaImage.remove();
        body.querySelectorAll('p').forEach(node => {
          if (node.textContent.trim().startsWith('If you found this interview fascinating,')) node.remove();
        });
        body.querySelectorAll('a[href*="PL3773rAGidqgf1vczbVUWp6t7vh3Fm1ez"]').forEach(link => {
          if (link.querySelector('img[src*="YouTube_Button.jpg"]')) link.remove();
        });
      }
      if (root.querySelector('h1')?.textContent.trim() === 'Billi Bierling') {
        body.querySelectorAll('p').forEach(node => {
          const text = node.textContent.replace(/\s+/g, ' ').trim();
          if (/^👉 Watch the.*presented by smzh$/i.test(text)) node.remove();
        });
        body.querySelectorAll('a[href="https://smzh.ch/de/flash-talk/flash-talk-mit-billi-bierling/"]').forEach(link => {
          if (link.querySelector('img')) link.remove();
        });
      }
      const mirjamImage = body.querySelector('img[src*="Mirjam_Staub-Bisang_Blazy_Flash_Talk_16-9.jpg"]');
      if (mirjamImage) {
        mirjamImage.remove();
        body.querySelectorAll('p').forEach(node => {
          if (node.textContent.trim().startsWith('If you found this interview fascinating,')) node.remove();
        });
      }
      body.querySelectorAll('p').forEach(node => {
        if (/with Pedro Schmidt is presented by smzh[.!]?$/i.test(node.textContent.trim()) && !node.querySelector('img,iframe,video')) node.remove();
      });
      body.querySelectorAll('h2,h3,h4').forEach(node => { if (root.dataset.intro && node.textContent.trim() === root.dataset.intro) node.remove(); });
      const marker = root.dataset.creditsMarker;
      const start = [...body.querySelectorAll('p,h2,h3,h4')].find(node => /^(About smzh|About WEEV):?$/i.test(node.textContent.trim()) || (marker && node.textContent.trim() === marker));
      if (start) {
        {
          const presenter = /About WEEV/i.test(start.textContent) ? 'WEEV' : /About smzh/i.test(start.textContent) ? 'smzh' : '';

          const preceding = start.previousElementSibling;
          if (presenter === 'smzh' && preceding && !preceding.textContent.trim() && preceding.querySelector('img[src*="smzh_logo"]')) {
            const introduction = preceding.previousElementSibling;
            start.after(preceding);
            if (introduction && /presented by\s*$/i.test(introduction.textContent.trim()) && !introduction.querySelector('img,iframe,video')) introduction.remove();
          }
          const details = document.createElement('details');
          details.className = 'bft-article__credits';
          const summary = document.createElement('summary');
          summary.textContent = root.dataset.creditsTitle;
          details.append(summary);
          const range = document.createRange();
          range.setStartBefore(start);
          const end = [...body.querySelectorAll('h2,h3,h4')].find(node => /^(More Flash)/i.test(node.textContent.trim()));
          if (end && (start.compareDocumentPosition(end) & Node.DOCUMENT_POSITION_FOLLOWING)) range.setEndBefore(end);
          else range.setEnd(body, body.childNodes.length);
          if (presenter) {
            const label = document.createElement('p');
            const strong = document.createElement('strong');
            strong.textContent = 'Presented by ' + presenter;
            label.append(strong);
            details.append(label);
          }
          details.append(range.extractContents());
          body.append(details);
        }
      }
      [...body.querySelectorAll('p,h1,h2,h3,h4,h5,h6')].reverse().forEach(node => {
        if (!node.textContent.replace(/\u00a0/g,' ').trim() && !node.querySelector('img,iframe,video,audio,picture,svg,object,embed')) node.remove();
      });
      body.querySelectorAll('h1').forEach(node => {
        const h2 = document.createElement('h2');
        while (node.firstChild) h2.append(node.firstChild);
        node.replaceWith(h2);
      });
      body.querySelectorAll('a[href^="www."]').forEach(link => link.setAttribute('href', 'https://' + link.getAttribute('href')));
      body.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; });
    }
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


